// @ts-nocheck

import React, { useContext, useLayoutEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Textarea,
  Tooltip,
  useToast,
  Spinner,
} from '@chakra-ui/react';

import LoadContext from 'hooks/useLoad';
import * as S from './styles';

export default function LoadAllScreen() {
  const { isLoad, setIsLoad, text, setText } = useContext(LoadContext);

  useLayoutEffect(() => {
    if (!isLoad) {
      setText('');
    }
  }, [isLoad]);

  return (
    <Modal
      size="full"
      isOpen={isLoad}
      onClose={() => {
        setIsLoad(value => !value);
      }}
    >
      <ModalContent
        bg="rgba(0, 0, 0, 0.5)"
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <S.centralize>
          <Spinner size="md" color="#469bff" />
          {text !== '' && <p>Carregando</p>}
        </S.centralize>
      </ModalContent>
    </Modal>
  );
}
